import type { ReactNode } from "react";

import { IgChip, IgDialog } from "@intelligems/ig-theme";
import { Box } from "@mui/material";

interface ModuleTrialWelcomeDialogViewProps {
  isOpen: boolean;
  trialDays: number;
  moduleDisplayName: string;
  description: string;
  graphic: ReactNode;
  goToModuleLabel: string;
  onClose: () => void;
  onGoToModule: () => void;
}

export function ModuleTrialWelcomeDialogView({
  isOpen,
  trialDays,
  moduleDisplayName,
  description,
  graphic,
  goToModuleLabel,
  onClose,
  onGoToModule,
}: ModuleTrialWelcomeDialogViewProps) {
  return (
    <IgDialog
      showDialog={isOpen}
      handleClose={onClose}
      handleNoClick={onClose}
      handleYesClick={onGoToModule}
      showCloseIcon={true}
      fullWidth={true}
      maxWidth="sm"
      dialogHeight={null}
      dialogContentWidth="100%"
      dialogImage={
        <IgChip
          color="primary"
          size="small"
          label={`${trialDays} days free`}
          sx={{ textTransform: "uppercase", fontWeight: 600, mb: 2 }}
        />
      }
      title={`You've unlocked ${trialDays} days of ${moduleDisplayName}!`}
      subtitle={description}
      content={
        <Box sx={{ borderRadius: 2, overflow: "hidden" }}>{graphic}</Box>
      }
      noButtonText="Do this later"
      yesButtonText={goToModuleLabel}
    />
  );
}
